import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {NgIf, NgOptimizedImage} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatHint} from "@angular/material/select";
import {MatInput} from "@angular/material/input";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_NATIVE_DATE_FORMATS,
  NativeDateAdapter
} from '@angular/material/core';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field";
import {MatButton} from "@angular/material/button";
import {AppointmentModel} from "../../../core/models/appointment.model";
import {CommentModel} from "../../../core/models/comment.model";
import {GtmEventDirective} from "../../../shared/directives/gtm-event.directive";

@Component({
  selector: 'feedback-form-accepted',
  templateUrl: './feedback-form-accepted.component.html',
  styleUrls: ['./feedback-form-accepted.component.scss'],
  imports: [
    TranslateModule,
    NgIf,
    FormsModule,
    MatInput,
    MatHint,
    MatFormField,
    ReactiveFormsModule,
    NgOptimizedImage,
    MatButton,
    GtmEventDirective
  ],
  providers: [
    {provide: DateAdapter, useClass: NativeDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'outline', floatLabel: 'always', subscriptSizing: 'dynamic'}
    }
  ],
  standalone: true
})
export class FeedbackFormAcceptedComponent implements OnInit {

  @Input() appointment!: AppointmentModel;

  @Output() formControlOutput = new EventEmitter<FormGroup>();
  @Output() outputData = new EventEmitter<CommentModel>();

  public messageSent: boolean = false;
  public submittedMessage: string = '';
  form!: FormGroup;
  textareaCtrl!: FormControl
  textareaValueLength: number = 0;

  constructor(private readonly fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      textarea: [''],
    });

    this.textareaCtrl = this.form.get('textarea') as FormControl;

    this.textareaCtrl.valueChanges.subscribe((res: any) => {
      this.textareaValueLength = this.textareaCtrl.value?.length || 0;
    });

  }

  send() {
    if (this.form.valid && this.textareaValueLength > 0) {
      this.submittedMessage = this.form.value.textarea;
      this.messageSent = true;
      const message: CommentModel = {
        description: this.submittedMessage,
      }
      this.outputData.emit(message);
    }
  }
}
